/** Preset options shown as checkboxes when creating/editing a course. */
export const PRESET_YOGA_STYLES = [
  'Hatha Yoga',
  'Raja Yoga',
  'Karma Yoga',
  'Bhakti Yoga',
  'Jnana Yoga',
  'Kundalini Yoga',
  'Tantra Yoga',
  'Ashtanga Yoga',
  'Dhyana Yoga',
  'Mantra Yoga',
  'Laya Yoga',
  'Nada Yoga',
  'Kriya Yoga',
  'Sahaja Yoga',
  'Integral Yoga',
  'Viniyoga',
  'Sivananda Yoga',
  'Iyengar Yoga',
  'Bihar Yoga',
  'Satyananda Yoga',
  'Kaivalya Yoga',
  'Patanjali Yoga',
  'Agama Yoga',
  'Shakta Yoga',
  'Shaiva Yoga',
  'Vaishnava Yoga',
  'Brahma Yoga',
  'Advaita Yoga',
  'Vinyasa Yoga',
] as const

const MAX_YOGA_STYLE_LENGTH = 80

/** Split custom input by comma or Enter; trim empty segments. */
export function parseCustomYogaStylesInput(raw: string): string[] {
  return raw
    .split(/[,;\n]+/)
    .map((s) => s.trim())
    .filter((s) => s.length > 0 && s.length <= MAX_YOGA_STYLE_LENGTH)
}

/** Add styles without duplicates (case-insensitive). */
export function mergeYogaStyles(current: string[], toAdd: string[]): string[] {
  const seen = new Set(current.map((s) => s.toLowerCase()))
  const next = [...current]
  for (const style of toAdd) {
    const key = style.toLowerCase()
    if (!seen.has(key)) {
      seen.add(key)
      next.push(style)
    }
  }
  return next
}
